'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var gqlUtils = require('@liquorice/gql-utils');
var FormieField = require('../FormieField/FormieField.js');
var React = require('react');

function _interopNamespaceDefaultOnly (e) { return Object.freeze({ __proto__: null, default: e }); }

const FORMIE_ROW_FRAGMENT = generatedCraftcms.gql(`
  fragment formieRow on RowInterface {
    __typename
    id
    rowFields {
      ...field
    }
  }
`);
const FormieRowContainer = /*#__PURE__*/ React.lazy(()=>Promise.resolve().then(function () { return /*#__PURE__*/_interopNamespaceDefaultOnly(require('../FormieRowContainer/index.js')); }));
const FormieRows = gqlUtils.withFragmentArray(FORMIE_ROW_FRAGMENT, (rows, { methods, parentHandle })=>{
    if (!rows) return null;
    return /*#__PURE__*/ jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: rows.map((row, rowIndex)=>{
            var _row_rowFields;
            if (!row || !((_row_rowFields = row.rowFields) == null ? void 0 : _row_rowFields.length)) return null;
            var _row_id;
            return /*#__PURE__*/ jsxRuntime.jsx(FormieRowContainer, {
                marginBottom: 4,
                children: row.rowFields.map((field, i)=>/*#__PURE__*/ jsxRuntime.jsx(FormieField, {
                        data: field,
                        methods: methods,
                        parentHandle: parentHandle
                    }, i))
            }, (_row_id = row.id) != null ? _row_id : rowIndex);
        })
    });
});

module.exports = FormieRows;
